
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect, useState } from 'react';
import { InferGetServerSidePropsType } from "next";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import SiteLayout from "@/components/layout/site";
import ActiveFilter from '@/components/fasce/ActiveFilter';
import FilterMenu from '@/components/fasce/FilterMenu';
import BannerResult from '@/components/fasce/BannerResult';
import CardList, { CardListLayout } from '@/components/fasce/CardList';
import CategoryList from '@/components/fasce/CategoryList';
import CmpPagination from '@/components/ui/Pagination';
import Stack from '@mui/material/Stack';
import Hero from '@/components/fasce/Hero';
import Breadcrumb from '@/components/fasce/Breadcrumb';
import { WPHeroHeight, WPHeroTextLightness } from '@/data/wp/operations/queries/fragments/fascia-hero-banner';
import Box from '@mui/material/Box';
import { PageType } from '@/utils/router';
import { getDefaultSortOrder, getServerSidePropsForProductByCategoryId } from '@/utils/slug';
import { getFilteredValuesByCategoryId } from '@/data/hcl/sdk/utils';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import placeholderCategory from '@/public/placeholder-category.svg';

// Aggiungere import per Tabs/Tab
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const GenericCategoryPage = ({ data }: InferGetServerSidePropsType<typeof getServerSideProps>) => {

  const router = useRouter();
  const { t } = useTranslation('common');
  const [filteredValues, setFilteredValues] = useState(data);
  let emptyFacets: any = [];
  const [facets, setFacets] = useState(emptyFacets);
  const [categoryPage, setCategoryPage] = useState(1);
  const [orderBy, setOrderBy] = useState(getDefaultSortOrder());
  const [filterNames, setFilterNames] = useState(data?._filterNames);
  // AGGIUNTO: State per tracciare i valori di ogni slider separatamente
  const [sliderValues, setSliderValues] = useState<Record<string, number[]>>({});

  const nameLabel = t('order-by-name-val');
  // nuovo stato per le tabs
  const [tabIndex, setTabIndex] = useState(0);

  /**
   * Funzione generica che gestisce una modifica alle opzioni di filtraggo dei prodotti in base ai parametri di query.
   * Aggiorna lo stato per orderBy, facets e recupera i dati filtrati.
   */
  const handleFilter = async (queryParams : any) => {
    console.log('=== GenericCategoryPage handleFilter ===');
    console.log('facets:', facets);
    console.log('queryParams:', queryParams);

    // Aggiorna lo stato orderBy
    if (!queryParams.orderBy){
      setOrderBy(getDefaultSortOrder());
    }else{
      setOrderBy(queryParams.orderBy);
    }

    // Gestisce l'aggiornamento della lista dei facet
    let facetList: any = [];
    let filterValue = queryParams.filterValue;
    let updatedSliderValues = { ...sliderValues };

    if (facets.includes(filterValue)) {
      // Rimuove il filtro se già presente
      facetList = facets.filter((item : any) => item !== filterValue);
      console.log('Rimuove il filtro se già presente', filterValue, facetList);
      setFacets(facetList);

    } else if (filterValue === null) {
      // Cancella tutti i facet
      facetList = [];
      console.log('Cancella tutti i filtri', facetList);
      setFacets([]);
      updatedSliderValues = {};
      setSliderValues({});

    } else if (filterValue === undefined) {
      // Mantiene i facet attuali
      facetList = facets;
      console.log('Mantiene i facet attuali', facetList);

    } else if (Array.isArray(filterValue)) {
      // Gestisce i filtri multipli (array)
      console.log('filterValue (caso Array): ', filterValue);

      if (filterValue.length === 0) {
        console.log('filterValue è un array vuoto -> setFacets([])');
        facetList = [];
        setFacets([]);

      } else if (!filterValue[0]) {
        console.log('filterValue è un array con primo elemento falsy -> non fa nulla');
        return;

      } else if (queryParams.sliderFilterValueDeleted && queryParams.facetId) {
        console.log('Rimuove filtro slider specifico dal facet e dai valori slider');
        let sliderFacetListTmp = facets.filter((x: string) => filterValue.indexOf(x) === -1);
        delete updatedSliderValues[queryParams.facetId];
        console.log('facetId:', queryParams.facetId);
        console.log('updatedSliderValues dopo delete:', updatedSliderValues);
        console.log('facetList dopo delete:', sliderFacetListTmp);
        setSliderValues(updatedSliderValues);
        queryParams.resetSlider = true;
        facetList = sliderFacetListTmp;
        setFacets(sliderFacetListTmp);

      } else {
        facetList = filterValue;
        console.log('Caso array else - Aggiorna i facet con i filtri multipli: ', filterValue);
        setFacets(filterValue);
      }

    } else {
      // Aggiunge nuovo filtro
      facetList = [...facets, filterValue];
      console.log('Aggiunge nuovo filtro', filterValue, facetList);
      setFacets([...facets, filterValue]);
    }

    // Prepara i parametri per la chiamata API
    let params = router.query;
    queryParams.params = params;
    queryParams.facetList = facetList;
    queryParams.orderBy = queryParams.orderBy ? queryParams.orderBy : '1';
    queryParams.filterNames = filterNames;

    // MODIFICATO: Gestione dei valori degli slider per facetId
    if (queryParams.displayValue && queryParams.facetId && !queryParams.sliderFilterValueDeleted) {
      updatedSliderValues[queryParams.facetId] = queryParams.displayValue;
      setSliderValues(updatedSliderValues);
    }

    // Passa sempre i valori aggiornati degli slider
    queryParams.sliderValues = updatedSliderValues;

    // Recupera i dati filtrati
    console.log('Recupera i dati filtrati', queryParams);
    const { data } = await getFilteredValuesByCategoryId(queryParams);
    // AGGIUNTO: Preserva i valori degli slider nella risposta
    data.sliderValues = updatedSliderValues;

    setFilteredValues(data);

    // Resetta la pagina se non specificato
    if(!queryParams.notResetPage) {
      setCategoryPage(parseInt(queryParams.pageNumber));
    }

    console.log('============================================');
  }

  const numOfCardListPerPage = 12;

  const handlePageChange = async (page: any, orderBy: string, storeData: any) => {
    setCategoryPage(page);
    setOrderBy(orderBy);
    let queryParams = {
      storeId: storeData.storeId,
      langId: storeData.langId,
      catalogId: storeData.catalogId,
      locale: storeData.locale,
      categoryId: storeData.categoryId,
      orderBy: orderBy,
      pageNumber: page.toString(),
      pageSize: numOfCardListPerPage.toString(),
      notResetPage: true,
      sliderValues: sliderValues // AGGIUNTO: Passa i valori degli slider anche nella paginazione
    }
    await handleFilter(queryParams);
  }

  const page = data?.pages?.nodes?.[0];

  // Aggiungere funzione handler per tab change
  const handleTabChange = async (_event: React.SyntheticEvent, newValue: number) => {
    // Se passo alla tab "Famiglie" (0) resetto tutti i filtri
    if (newValue === 0) {
      try {
        // resetto i filtri
        const queryParams = {
          storeId: data?._products?.[0]?.storeId,
          langId: data?.langId,
          catalogId: data?.catalogId,
          locale: data?.locale,
          categoryId: data?._products?.[0]?.categoryId,
          filterValue: null,
          sliderFilterValueDeleted: true,
          facetId: null, // identifica che è un reset generale di tutti gli slider
          orderBy: orderBy,
          pageNumber: '1',
          pageSize: numOfCardListPerPage.toString(),
        }
        console.log('handleTabChange(0=family)', queryParams, categoryCards);
        await handleFilter(queryParams);
      } catch (e) {
        console.warn('handleTabChange(0=family) error', e);
      }

      // reset visualizzazione famiglie alla lista principale e svuota lo stack
      setCurrentCategoryCards(categoryCards);
      setCategoryStack([]);
      setTabIndex(0);
      return;
    }

    // se l'utente ha selezionato una famiglia e poi passa alla tab Prodotti, applico il filtro della famiglia selezionata
    // prendo l'ultimo elemento dello stack (se esiste) per recuperare il filtro della famiglia selezionata
    const lastStackItem = categoryStack.length > 0 ? categoryStack[categoryStack.length - 1] : undefined;
    const filterValue = lastStackItem?.parentId;
    if (filterValue !== undefined) {
      try {
        const queryParams = {
          storeId: data?._products?.[0]?.storeId,
          langId: data?.langId,
          catalogId: data?.catalogId,
          locale: data?.locale,
          categoryId: data?._products?.[0]?.categoryId,
          orderBy: orderBy,
          pageNumber: '1',
          pageSize: numOfCardListPerPage.toString(),
          filterValue: filterValue
        };
        console.log('handleTabChange(1=tutti) apply filters', categoryStack, filterValue, queryParams);
        // Chiama la funzione che gestisce i filtri (aggiorna facets, filteredValues, ecc.)
        await handleFilter(queryParams);
      } catch (e) {
        console.error('handleTabChange(1=tutti) apply filter error', e);
      }
    } else {
        console.log('handleTabChange(1=tutti) filterValue undefined, nessun filtro applicato');
    }
    setTabIndex(newValue);
  };

  // --- Nuova logica: ricava le categorie figlie dalla chiave accordionCheckbox del primo facet ---
  const childCategories = data?._facets?.[0]?.accordionCheckbox || [];

  // Mappa le categorie figlie nel formato minimale richiesto: title (dalla label) e id (dal value).
  // NOTA: value viene mantenuto come id così come arriva (se serve trasformarlo ulteriormente, aggiungere parsing qui).
  const categoryCards = (childCategories || []).map((cat: any) => ({
    title: cat.label || '',
    id: cat.value || undefined,
    children: cat.children || undefined,
    image: cat.image || undefined // <-- aggiunto supporto immagine
  }));

  // nuovo stato per le categorie correnti visualizzate (può diventare la lista dei figli)
  const [currentCategoryCards, setCurrentCategoryCards] = useState(categoryCards);
  // stack per tornare indietro tra livelli — ora memorizza { cards: CategoryItem[], parentId?: string, title?: string }
  const [categoryStack, setCategoryStack] = useState<{ cards: any[]; parentId?: string; title?: string }[]>([]);

  useEffect(() => {
    console.log('useEffect - route changed - reset states', router.query.slug, data);
    setFilteredValues(data);
    setFacets([]);
    setCategoryPage(1);
    setOrderBy(getDefaultSortOrder());
    setFilterNames(data?._filterNames);
    // reset delle categorie visualizzate quando cambia la sorgente dati / route
    setCurrentCategoryCards((data?._facets?.[0]?.accordionCheckbox || []).map((cat: any) => ({
      title: cat.label || '',
      id: cat.value || undefined,
      children: cat.children || undefined,
      image: cat.image || undefined // <-- sincronizza immagine anche nel reset
    })));
    // svuota lo stack quando cambia la sorgente dati / route
    setCategoryStack([]);
  }, [router.query.slug, data]);

  // Handler per click su category card: switch tab e "simula" il click del filtro corrispondente (checkbox)
  const handleCategoryClick = async (id?: string, item?: any) => {
    if (!id) return;

    // // Gestione card "Torna indietro"
    // if (id === '__BACK__') {
    //   // pop dallo stack
    //   setCategoryStack(prevStack => {
    //     if (!prevStack || prevStack.length === 0) {
    //       // nessuno stack -> ripristina principale
    //       console.log('handleCategoryClick - BACK no prevStack', categoryCards);
    //       setCurrentCategoryCards(categoryCards);
    //       return [];
    //     }
    //     const newStack = [...prevStack];
    //     const prev = newStack.pop()!;
    //     // ripristina le cards salvate
    //     console.log('handleCategoryClick - BACK prevStack', newStack);
    //     setCurrentCategoryCards(prev.cards);
    //     return newStack;
    //   });
    //   // rimango su tab Famiglie
    //   setTabIndex(0);
    //   return;
    // }

    // Se l'item ha figli, push della lista corrente nello stack e mostro i figli (in testa aggiungo la card back)
    if (item && Array.isArray(item.children) && item.children.length > 0) {
      setCategoryStack(prev => [...prev, { cards: currentCategoryCards, parentId: item.id, title: item.title }]);
      const mappedChildren = item.children.map((child: any) => ({
        title: child.label || '',
        id: child.value || undefined,
        children: child.children || undefined,
        image: child.image || undefined // <-- includo immagine del figlio
      }));
      console.log('handleCategoryClick - mostro sottofamiglie', mappedChildren);

      // const backTitle = t('card-category-level-parent');
      // const backItem = { title: backTitle, id: '__BACK__', _isBack: true };
      // setCurrentCategoryCards([backItem, ...mappedChildren]);
      setCurrentCategoryCards([...mappedChildren]);

      // rimango sulla tab Famiglie (tabIndex = 0)
      setTabIndex(0);
      return;
    }

    // Passo alla tab prodotti e applico il filtro chiamando handleFilter direttamente
    setTabIndex(1);
    try {
      // // quando possibile, includiamo anche il filtro del padre per coerenza (parent + child)
      // const lastStackItem = categoryStack.length > 0 ? categoryStack[categoryStack.length - 1] : undefined;
      // const parentFilter = lastStackItem?.parentId;
      // const filterValue = parentFilter ? [parentFilter, id] : id;
      const filterValue = id;
      const queryParams = {
        storeId: data?._products?.[0]?.storeId,
        langId: data?.langId,
        catalogId: data?.catalogId,
        locale: data?.locale,
        categoryId: data?._products?.[0]?.categoryId,
        orderBy: orderBy,
        pageNumber: '1',
        pageSize: numOfCardListPerPage.toString(),
        filterValue: filterValue
      };
      console.log('handleCategoryClick - switch to products', queryParams);
       // Chiama la funzione che gestisce i filtri (aggiorna facets, filteredValues, ecc.)
       await handleFilter(queryParams);
     } catch (e) {
       console.warn('handleCategoryClick apply filter error', e);
     }
   };

  /**
   * Genera i breadcrumb nel formato atteso dal componente Breadcrumb
   * per la sezione Famiglie (in aggiunta a quelli di categoria come per pdp).
   */
  const generateFamiliesBreadcrumbs = (): any[] => {
    // Se lo stack è vuoto, restituisci quelli della categoria
    if (categoryStack.length === 0) {
      return filteredValues._breadcrumbs;
    }

    // Crea i breadcrumb partendo da quelli della categoria filtrata
    const baseBreadcrumbs = [...filteredValues._breadcrumbs];

    // Aggiunge i breadcrumb della navigazione nelle famiglie derivati dallo stack
    const familiesBreadcrumbsFormatted = categoryStack.map((stackItem) => {
      return {
        links: [
          {
            __typename: "DefaultTemplate_Fasce_Fasce_Showroom-List_Links_LinkInterno",
            linkInterno: {
              id: '',
              slug: stackItem.parentId,
              uri: '',
              title: stackItem.title
            },
            label: stackItem.title,
            target: null,
            variante: 'plainLink',
            colore: 'primary',
            dimensione: 'large',
            disableClientSideNavigation: false
          }
        ]
      };
    });

    return [...baseBreadcrumbs, ...familiesBreadcrumbsFormatted];
  };
  return (
    <SiteLayout pageType={PageType.PLP} data={data} translations={page?.translations} seo={page?.seo} language={page?.language}>

      <Hero
        height={WPHeroHeight.small}
        slides={[
          {
            backgroundImage: {
              id: 'hero-image',
              mimeType: data?.categoryData?.fullImage ? 'image/jpeg': 'image/svg+xml',
              mediaItemUrl: data?.categoryData?.fullImage ? data?.categoryData?.fullImage : placeholderCategory,
              mediaDetails: { width: 1440, height: 267 }
            },
            textLightness: WPHeroTextLightness.dark,
            title: data?.categoryData?.name,
          },
        ]}
      />

      <Container sx={{paddingTop: '40px'}}>

        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="views tabs" centered sx={{ mb: 2 }}>
          <Tab label="Famiglie" id="tab-0" aria-controls="tabpanel-0" />
          <Tab label="Tutti i Prodotti" id="tab-1" aria-controls="tabpanel-1" />
        </Tabs>

        {/* TabPanel 0: contenuto alternativo/minimale */}
        <Box
          role="tabpanel"
          hidden={tabIndex !== 0}
          id="tabpanel-0"
          aria-labelledby="tab-0"
          sx={{ display: tabIndex === 0 ? 'block' : 'none', mb: 2 }}
        >
          <Box sx={{ p: 2 }}>

            <Breadcrumb breadcrumbs={generateFamiliesBreadcrumbs()} />

            {/* Se ci sono categorie figlie, le mostro come CategoryList a 4 colonne */}
            {categoryCards && categoryCards.length > 0 ? (
              <Box sx={{mx: { xs: '-16px', sm: '-24px'}}}>
                <CategoryList
                  whiteCardList={currentCategoryCards}
                  columns={4}
                  // style personalizzabile per la singola card
                  cardSx={{ textAlign: 'center', height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  titleSx={{ fontWeight: 700 }}
                  onCardClick={(id, item) => handleCategoryClick(id, item)}
                />
              </Box>
            ) : (
              /* fallback: mostra descrizione se presente */
              data?.categoryData?.shortDescription && (
                <Box dangerouslySetInnerHTML={{ __html: data.categoryData.shortDescription }} />
              )
            )}
          </Box>
        </Box>

        {/* TabPanel 1: qui è stato spostato il Grid originale */}
        <Box
          role="tabpanel"
          hidden={tabIndex !== 1}
          id="tabpanel-1"
          aria-labelledby="tab-1"
          sx={{ display: tabIndex === 1 ? 'block' : 'none' }}
        >
          <Grid container sx={{ mb: '50px'}}>
            <Grid item xs={12} md={3}>

              <FilterMenu
                accordions={filteredValues?._facets}
                facets= {facets}
                dataModal={{
                  btnOpenModal: t('btn-open-modal-filter'),
                  title: t('modal-title-filter'),
                  backButton: t('btn-back-modal-filter'),
                  confirmButton: t('btn-confirm-modal-filter')
                }}
                storeData = {{
                  storeId: data._products[0].storeId,
                  langId: data.langId,
                  catalogId: data.catalogId,
                  locale: data.locale,
                  orderBy: orderBy,
                  categoryId : data._products[0].categoryId,
                  pageNumber: '1',
                  pageSize: numOfCardListPerPage.toString()
                }}
                handleFilter = {
                  handleFilter
                }
              />

            </Grid>
            <Grid item xs={12} md={9}>

              <ActiveFilter
                title={t('active-filter-title')}
                chips={filteredValues?._activeFilters}
                storeData = {{
                  storeId: data._products[0].storeId,
                  langId: data.langId,
                  catalogId: data.catalogId,
                  locale: data.locale,
                  orderBy: orderBy,
                  categoryId : data._products[0].categoryId,
                  pageNumber: '1',
                  pageSize: numOfCardListPerPage.toString()
                }}
                handleFilter = {
                  handleFilter
                }
                btnRemoveFilters={t('active-filter-remove-filter-btn')}
              />

              <BannerResult
                resultNumber={filteredValues?.recordSetTotal}
                orderList={[
                  {
                    label: nameLabel,
                    value: '2'
                  }
                ]}
                selectedOrderBy = {orderBy}
                storeData = {{
                  storeId: data._products[0].storeId,
                  langId: data.langId,
                  catalogId: data.catalogId,
                  locale: data.locale,
                  orderBy: orderBy,
                  categoryId : data._products[0].categoryId,
                  pageNumber: '1',
                  pageSize: numOfCardListPerPage.toString()
                }}
                handleFilter = {
                  handleFilter
                }
              />

              <Box sx={{mx: { xs: '-16px', sm: '-24px'}}}>
                <CardList
                  layout={CardListLayout.ThreeColumns}
                  whiteCardList={filteredValues?._products}
                />
              </Box>

              {filteredValues?.recordSetTotal > 0 && (
              <Stack direction="row" sx={{ mb: '20px', padding: '0 16px' }}>
                <CmpPagination numOfPage={Math.ceil(filteredValues?.recordSetTotal / numOfCardListPerPage)} page={categoryPage} onChange={(_e,categoryPage) => handlePageChange(categoryPage, orderBy, {
                  storeId: data._products[0].storeId,
                  catalogId: data.catalogId,
                  langId: data.langId,
                  locale: data.locale,
                  categoryId : data._products[0].categoryId
                })} />
              </Stack>
              )}
            </Grid>
          </Grid>
        </Box>

      </Container>


    </SiteLayout>
  );
};

export default GenericCategoryPage;

 const _getServerSideProps = getServerSidePropsForProductByCategoryId;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/cat/[brand]/[category]/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  